<template>
  <Loading v-if="isLoading" />
  <div v-else class="coupons-container">
    <Market :markets="marketGroup" @handle-get-market="handleUpdateMarket" />
    <div class="toolbar__container">
      <BalanceDisplay />
      <div class="toolbar__actions">
        <button class="action__watch-live" @click="openWatchLive">
          <img src="../../public/images/play.svg" />
          <span>{{ getTranslatedText("Watch Live") }}</span>
        </button>

        <button class="action__cart" @click="openCart">
          <i class="bi bi-cart3"></i>
          <span class="cart_quantity__container" v-if="noOfItemInCart">
            {{ noOfItemInCart }}
          </span>
        </button>
      </div>
    </div>
    <div class="coupons-content">
      <Standard
        v-if="market === 'standard' || market === 'standard-plus-bonus'"
        :marketSlug="market"
        :gameSlug="currentGameSlug"
      />
      <Combination
        v-else-if="market === 'combinations'"
        :marketSlug="market"
        :game="gameData"
      />
      <Special v-else-if="market" :marketSlug="market" />
      <ButtonCommon
        text="Back Home"
        class="button__custom-1"
        @action="backToHome"
      />
    </div>

    <LiveStreamModal
      :visible="visibleModalLiveStream"
      :gameId="gameId"
      @close="handleCloseLiveStreamModal"
    />
  </div>
</template>
<script>
import utilsMixins from "@/mixins/function-utils";
import languageMixins from "@/mixins/language-mixins";
import Market from "./components/market.vue";

import Loading from "@/components/common/loading/loading.vue";
import ButtonCommon from "@/components/common/button";

import Standard from "./standard.vue";
import Combination from "./combination.vue";
import Special from "./special.vue";
import EventBus from "@/utils/EventBus";
import LiveStreamModal from "@/components/live-stream/index.vue";
import HomeService from "@/services/home/index.service.ts";
import BalanceDisplay from "../common/BalanceDisplay.vue";

export default {
  mixins: [languageMixins, utilsMixins],
  components: {
    Standard,
    Combination,
    Special,
    Market,
    Loading,
    ButtonCommon,
    BalanceDisplay,
    LiveStreamModal,
  },

  data() {
    return {
      isShowPopup: false,
      isDisableAddButton: true,
      isLoading: false,
      market: "",
      gameData: null,
      gameId: 0,
      marketGroup: [],
      visibleModalLiveStream: false,
      fetchingMarket: false,
    };
  },
  computed: {
    currentGameSlug() {
      return this.$route.params.gameSlug;
    },
    noOfItemInCart() {
      return (
        this.$store.state.stateBetslip?.betslips?.[this.$store.state.accountKey]
          ?.length || 0
      );
    },
  },
  watch: {
    "$route.params.gameSlug"(gameSlug) {
      if (gameSlug) {
        this.getDataGame(gameSlug);
      }
    },
    // Home loads this list. A slow response used to leave the page rendering
    // with no game, which threw when the market groups were read.
    "$store.state.gameMarket"() {
      if (this.$route.params.gameSlug) {
        this.applyGame(this.$route.params.gameSlug, false);
      }
    },
  },
  created() {
    this.getDataGame();
    EventBus.on("play-live-stream", (visible) => {
      this.visibleModalLiveStream = visible;
    });
  },
  unmounted() {
    EventBus.off("play-live-stream");
  },
  methods: {
    openCart() {
      document.getElementById("betslip-header")?.click();
    },
    openWatchLive() {
      this.visibleModalLiveStream = true;
    },
    getDataGame(gameSlugParams) {
      this.visibleModalLiveStream = false;
      const gameSlug = gameSlugParams ?? this.$route.params.gameSlug;
      if (!this.applyGame(gameSlug, true)) {
        this.fetchGameMarket();
      }
    },

    applyGame(gameSlug, resetMarket) {
      const game = (this.$store.state.gameMarket || []).find(
        (x) => x.slug == gameSlug
      );
      if (!game) {
        this.isLoading = true;
        this.gameData = null;
        this.marketGroup = [];
        this.market = "";
        return false;
      }

      const groups = game.groups || [];
      this.gameData = game;
      this.gameId = game.id;
      this.marketGroup = groups;
      if (resetMarket || !groups.some((group) => group.slug === this.market)) {
        this.market =
          this.$store.state.stateAction.marketSelected || groups[0]?.slug || "";
      }
      this.isLoading = false;
      return true;
    },

    async fetchGameMarket() {
      if (this.fetchingMarket) return;
      this.fetchingMarket = true;
      try {
        const res = await HomeService.getGameMarket();
        if (res && res.status === "success" && Array.isArray(res.result)) {
          this.$store.commit("SET_GAME_MARKET", res.result);
        }
      } catch (error) {
        // Keep the loading state. The failed request is already reported by the API layer.
      } finally {
        this.fetchingMarket = false;
        this.applyGame(this.$route.params.gameSlug, false);
      }
    },

    handleUpdateMarket(marketSlug) {
      this.market = marketSlug;
    },

    backToHome() {
      const query = this.$route.query;
      this.$router.push({ path: "/", query });
    },

    handleCloseLiveStreamModal() {
      this.visibleModalLiveStream = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/coupons/index.scss";
.toolbar__container {
  padding: 10px var(--padding-page);
  text-align: center;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f0f0;

  > span {
    color: #4a4a4a;
  }
}

.toolbar__actions {
  display: flex;
  gap: 10px;
}

.action__cart {
  border: none;
  background: inherit;
  color: #0961da;
  font-size: 22px;
  padding-right: 15px;
  position: relative;
}

.cart_quantity__container {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: var(--bg-button);
  border-radius: 50%;
  cursor: pointer;
  color: var(--color-text);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  top: 0;
  right: 0;
}

.action__watch-live {
  display: flex;
  background: inherit;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 5px;
  border: 2px solid #ff7700;
  border-radius: 6px;
  color: #000;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
</style>
